import { createExternalStore } from '@iheartjane/utils';
import { useSyncExternalStore } from 'react';

const MODAL_OPEN_BODY_CLASS = 'ReactModal__Body--open';

const { notify, subscribe } = createExternalStore();
let bodyClassObserver: MutationObserver | null = null;
let subscriberCount = 0;

const subscribeToBodyClass = (onChange: () => void) => {
  const unsubscribe = subscribe(onChange);
  subscriberCount += 1;
  if (!bodyClassObserver) {
    bodyClassObserver = new MutationObserver(notify);
    bodyClassObserver.observe(document.body, {
      attributeFilter: ['class'],
      attributes: true,
    });
  }

  return () => {
    unsubscribe();
    subscriberCount -= 1;
    if (subscriberCount === 0) {
      bodyClassObserver?.disconnect();
      bodyClassObserver = null;
    }
  };
};

const getIsModalOpen = () =>
  document.body.classList.contains(MODAL_OPEN_BODY_CLASS);

/**
 * Reports whether any `react-modal` modal is open, anywhere in the app.
 *
 * react-modal reports itself by toggling a class on `<body>`
 *
 * Dev-only caveat: StrictMode mounts everything twice. If a modal is already
 * open on that first mount, react-modal loses track of the class and never
 * removes it, so this hook stays `true` for the rest of the session. Prod
 * builds mount once, so it does not happen there.
 */
export const useIsModalOpen = (): boolean =>
  useSyncExternalStore(subscribeToBodyClass, getIsModalOpen, () => false);
